import { render, staticRenderFns } from "./KidDashboard.vue?vue&type=template&id=5deaf87d&scoped=true&"
import script from "./KidDashboard.vue?vue&type=script&lang=js&"
export * from "./KidDashboard.vue?vue&type=script&lang=js&"
import style0 from "./KidDashboard.vue?vue&type=style&index=0&id=5deaf87d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5deaf87d",
  null
  
)

export default component.exports